import React from 'react';
import { TouchableOpacity } from 'react-native';
import Ionicons from '@react-native-vector-icons/ionicons/static';
import { iconSize, s } from '../../../utils/libs';
import { isTablet } from 'react-native-device-info';
export const HeaderLeft = (props: any) => {
  const padding = typeof props?.padding === 'number' ? props.padding : s(5);
  return (
    <TouchableOpacity
      style={[{ padding }, props?.style]}
      onPress={props.onPress}
      accessibilityRole="button"
      accessibilityLabel={props?.accessibilityLabel || 'Go back'}>
      <Ionicons
        name="chevron-back-outline"
        size={iconSize(isTablet() ? 22 : 24)}
        color="white"
      />
    </TouchableOpacity>
  );
};

export default HeaderLeft;
